import {createSlice} from '@reduxjs/toolkit'

const initialState = { 
    isLoading:false,
    loadedEvent: false,
    loadingEvent: false,
    loadingContent: "Loading Please Wait",
    pastEvent:"",
    duplicateEvent: null,
    error:"" 
}

const pastEventSlice = createSlice({
    name:"past-event",
    initialState,
    reducers:{
        pastEventLoading:(state) => {
            state.isLoading = true
        },
        pastEventItemList:(state, {payload}) => {
            state.pastEvent = payload
            state.isLoading = false
        },
        pastEventError:(state, {payload}) => {
            state.error = payload
        },
        setLoadedEvent: (state, {payload}) => {
            state.loadedEvent = payload
        },
        setLoadingEvent: (state, {payload}) => {
            state.loadingEvent = payload
        },
        setLoadingContent: (state, {payload}) => {
            state.loadingContent = payload
        },
        setDuplicateEvent: (state, {payload}) => {
            state.duplicateEvent = payload
        }
    }
})

export const { 
    pastEventLoading,
    pastEventItemList,
    pastEventError,
    setLoadedEvent,
    setLoadingEvent,
    setLoadingContent,
    setDuplicateEvent
} = pastEventSlice.actions
export default pastEventSlice.reducer